








































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {CategoryModel} from '@/models/category.model';
import ChallengeCard from '@/components/ChallengeCard.vue';
import RequestStatus from '@/components/RequestStatus.vue';
import {ChallengeModel} from '@/models/challenge.model';
import {CategoriesApi} from '@/api/categories.api';
import {take} from 'rxjs/operators';
import {acceptedModule, acceptedState, userModule, userState} from '@/utils/store-acessor';
import {UserModel} from '@/models/user.model';

@Component({
  components: {
    ChallengeCard,
    RequestStatus,
  },
})
export default class CategoriesChallenges extends Vue {
  @userModule.Getter('user') user!: UserModel;
  @Prop({required: true})
  category!: CategoryModel;
  @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (challengeId: number) => boolean;

  searchValue: string = '';
  searching: boolean = false;

  challenges: ChallengeModel[] | null = null;

  filteredChallenges: ChallengeModel[] | null = null;

  async mounted() {
    await acceptedState.fetchAcceptedChallenges({
      params: {
        page: 1
      }
    });
    this.getChallenges();
  }

  openChallenge(slug: string) {
    this.$router.push(`/challenges/${slug}`)
  }

  @Watch('searchValue', {deep: true, immediate: true})
  async search(query: string) {
    if (query.length >= 3) {
      this.searching = true;
      (new CategoriesApi())
        .getChallenges(this.category.id, query)
        .pipe(take(1))
        .toPromise()
        .then((challenges) => {
          this.searching = false;
          this.filteredChallenges = challenges
        })
    }
  }

  @Watch('category', {deep: true, immediate: true})
  async getChallenges() {
    if (this.category && this.category.id) {
      await (new CategoriesApi())
        .getChallenges(this.category.id)
        .pipe(take(1))
        .toPromise().then((challenges) => {
          this.searching = false;
          this.challenges = challenges
        })
    }
  }

  get hasChallenges(): boolean {
    return !this.challenges || (this.challenges && this.challenges.length < 1)
  }

  get challengeIsEmpty(): boolean {
    return !!this.challenges && this.challenges.length < 1
  }
}

